<template>
  <div id="info">
    <!-- <div class="page-banner1">
      <img class="bg-img" :src="banner.imgUrl">
    </div> -->
    <!-- <div class="crumbs hidden-xs-only"><router-link to="/">首页</router-link> >> 信息公开</div> -->
    <div class="header-nav">
      <a class="tab-item" :class="{active: v.colId == colId}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v)">{{v.cnName}}</a>
    </div>
    <div class="nav-wrap">
      <div class="nav-title">信息公开</div>
    </div>
    <div id="info_home">
      <!-- <div class="battle-tab green">
        <a class="tab-item" :class="{active: v.colId == colId}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v)">{{v.cnName}}</a>
      </div> -->
      <div>
        <file-list ref="filelist" :colid="colId"></file-list>
      </div>
    </div>
  </div>
</template>

<script>
import FileList from '@/components/FileList'

//import {getBannersByColId} from '@/api/project'
import {getColumns} from '@/api/home'

export default {
  components: {
    FileList
  },
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      menu_list: [],
      colId: ''
    }
  },
  mounted() {
    this.$store.commit('setCurrentMenuI', 4)
    // getBannersByColId(this.$route.params.cid).then(res => {
    //   if (res) {
    //     this.banner = res[0]
    //   }
    // })
    getColumns(this.$route.params.cid).then(res => {
      if (res) {
        this.menu_list = res[0].subList
        if (!this.$route.params.aid) {
          if (res[0].subList.length > 0) {
            this.colId = res[0].subList[0].colId
            this.$router.replace(`/info/${this.$route.params.cid}/${this.colId}`)
            this.$refs.filelist.loadData(this.colId)
          }
        } else {
          this.colId = this.$route.params.aid
          this.$refs.filelist.loadData(this.colId)
        }
      }
    })
  },
  methods: {
    tabHandle(pData) {
      this.$router.push(`/info/${this.$route.params.cid}/${pData.colId}`)
      this.colId = pData.colId
      this.$refs.filelist.loadData(this.colId)
    }
  }
}
</script>

<style lang="scss" scoped>
  @media only screen and (min-width: 768px) {
    // #info_home {
    //   padding: 0 rem(225) rem(100) rem(225);
    // }
    .nav-wrap {
      padding: 0 rem(88) 0 rem(75);
    }
    #info_home {
      padding: 0 rem(75);
    }
  }
  @media only screen and (max-width: 768px) {
    #info_home {
      padding: 0 .575rem rem(100) .575rem;
    }
    .battle-tab {
      margin-top: .74rem;
    }
  }
</style>
